import { HttpParams } from '@angular/common/http';

import { toHTTPParam } from '../../../../core';
import { periodicidadeDiaria } from '../integration-periodicidade';

export class IntegrationRepresentante {
    periodicidade: number;
    dataCadastroBase: Date;

    constructor() {
        this.periodicidade = periodicidadeDiaria.id;
    }

    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Periodicidade
        if (this.periodicidade) {
            params = params.append('periodicidade', this.periodicidade.toString());
        }
        // Data Cadastro Base
        if (this.dataCadastroBase) {
            params = params.append('dataCadastroBase', toHTTPParam(this.dataCadastroBase));
        }
        // Execução manual
        params = params.append('manual', 'true');

        return params;
    }

    clear() {
        this.periodicidade = periodicidadeDiaria.id;
        this.dataCadastroBase = null;
    }
}
